import IsMobile from "ismobilejs"

/**
 * Check if current device is a mobile device
 * @returns {boolean}
 */
export function isMobileDevice() {
	return IsMobile().any
}

/**
 * Find current breakpoint
 * @returns {string}
 */
export function getBreakpoint() {
	let curBreakpoint = window.getComputedStyle(document.body, ":before").getPropertyValue("content")

	if (curBreakpoint.charAt(0) === '"') {
		curBreakpoint = curBreakpoint.slice(1)
		curBreakpoint = curBreakpoint.slice(0, -1)
	}

	return curBreakpoint
}

/**
 * convert files to base64
 * @param file
 * @param successCallback
 * @param errorCallback
 */
export function convertToBase64(file, successCallback, errorCallback) {
	let reader = new FileReader()
	reader.readAsDataURL(file)
	reader.onload = () => {
		successCallback(reader.result, file)
	}
	reader.onerror = () => {
		errorCallback()
	}
}

export function getInternetExplorerVersion() {
	let rv = -1
	if (navigator.appName == "Microsoft Internet Explorer") {
		let ua = navigator.userAgent
		let re = new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})")
		if (re.exec(ua) != null) rv = parseFloat(RegExp.$1)
	} else if (navigator.appName == "Netscape") {
		let ua = navigator.userAgent
		let re = new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})")
		if (re.exec(ua) != null) rv = parseFloat(RegExp.$1)
	}
	return rv
}

export function getHashParams() {
	let hashParams = {}
	let e,
		a = /\+/g, // Regex for replacing addition symbol with a space
		r = /([^&;=]+)=?([^&;]*)/g,
		d = function (s) {
			return decodeURIComponent(s.replace(a, " "))
		},
		q = window.location.hash.substring(1)

	while ((e = r.exec(q))) {
		hashParams[d(e[1])] = d(e[2])
	}

	return hashParams
}

export function updateQueryStringParam(key, value) {
	let baseUrl = [location.protocol, "//", location.host, location.pathname].join(""),
		urlQueryString = document.location.search,
		newParam = key + "=" + value,
		params = "?" + newParam

	// If the "search" string exists, then build params from it
	if (urlQueryString) {
		const updateRegex = new RegExp("([?&])" + key + "[^&]*")
		const removeRegex = new RegExp("([?&])" + key + "=[^&;]+[&;]?")

		if (typeof value == "undefined" || value == null || value == "") {
			// Remove param if value is empty
			params = urlQueryString.replace(removeRegex, "$1")
			params = params.replace(/[&;]$/, "")
		} else if (urlQueryString.match(updateRegex) !== null) {
			// If param exists already, update it
			params = urlQueryString.replace(updateRegex, "$1" + newParam)
		} else {
			// Otherwise, add it to end of query string
			params = urlQueryString + "&" + newParam
		}
	}

	// no parameter was set so we don't need the question mark
	params = params == "?" ? "" : params

	window.history.replaceState({}, "", baseUrl + params)
}

export async function copyToClipBoard(text) {
	const type = "text/plain"
	const clipboardItemData = {
		[type]: text,
	}
	const clipboardItem = new ClipboardItem(clipboardItemData)
	await navigator.clipboard.write([clipboardItem])
}
